import { render, staticRenderFns } from "./ShipmentAttachmentDialog.vue?vue&type=template&id=40056e92"
import script from "./ShipmentAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./ShipmentAttachmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports